import { EloIntlProvider } from './EloIntlProvider';
import enUs from './messages/en-us';
import pt from './messages/pt-br';
import { flattenMessages } from './utils';

const messages = {
  pt,
  'pt-BR': pt,
  'en-US': enUs
};

const getMessages = (locale: string) => {
  return Promise.resolve(messages[locale]);
};

export { flattenMessages, getMessages, EloIntlProvider };
